import { Component, OnInit } from '@angular/core';
import { GotovinskiKomitent } from './gotovinski-komitent';
import { BaseUpdateComponent, BaseDataService, CompanyDataService, CompanyData, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-gotovinski-komitent-update',
  templateUrl: './gotovinski-komitent-update.component.html'
})
export class GotovinskiKomitentUpdateComponent extends BaseUpdateComponent<GotovinskiKomitent> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected companyDataService : CompanyDataService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  checkPib:boolean = false;
  checkMaticniBroj:boolean = false;
  loadingCompanyData:boolean = false;

  ngOnInit() {
    super.ngOnInit();

    this.addValidatorToFc('Naziv', Validators.required, 'required', 'GOTOVINSKIKOMITENT.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc('Naziv', Validators.maxLength(200), 'required', 'GOTOVINSKIKOMITENT.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc('Pib', Validators.required, 'required', 'GOTOVINSKIKOMITENT.PIB.VALIDATION.REQUIRED');
    this.addValidatorToFc('Pib', Validators.maxLength(9), 'required', 'GOTOVINSKIKOMITENT.PIB.VALIDATION.MAXLENGTH');
    this.addValidatorToFc('MatBr', Validators.maxLength(8), 'required', 'GOTOVINSKIKOMITENT.MATBR.VALIDATION.MAXLENGTH');
    this.addValidatorToFc('Adresa', Validators.maxLength(200), 'required', 'GOTOVINSKIKOMITENT.ADRESA.VALIDATION.MAXLENGTH');
    this.addValidatorToFc('MestoID', Validators.required, 'required', 'GOTOVINSKIKOMITENT.MESTO.VALIDATION.REQUIRED');


  }

  GetCompanyDataByPib(){
      if(!this.baseFormGroup.get('Pib').value || this.baseFormGroup.get('Pib').value == '' || this.fc.Pib.invalid){
          this.checkPib = true;
          return;
      }    
      this.loadingCompanyData = true;
      this.companyDataService.GetCompanyDataByTaxNo(this.baseFormGroup.get('Pib').value)
          .subscribe((data: CompanyData[]) => {
              this.loadingCompanyData = false;
              if(!data || data.length == 0){
                this.translateService.get(['NBS.PIB.WARNING'])
                  .subscribe(translate => {
                    // this.notificationsService.alert(translate['NBS.PIB.WARNING']);
                    this.toastrService.info(translate['NBS.PIB.WARNING']);
                    return;
                  });
                  // alert('Ne postoje podaci za uneti PIB');
                  // return;
              }
              this.setCompanyData(data[0]);
          })    
  }

  GetCompanyDataByMatBr(){
      if(!this.baseFormGroup.get('MaticniBroj').value || this.baseFormGroup.get('MaticniBroj').value == '' || this.fc.MaticniBroj.invalid){
          this.checkMaticniBroj = true;
          return;
      }    
      this.loadingCompanyData = true;
      this.companyDataService.GetCompanyDataByNationalIdentificationNo(this.baseFormGroup.get('MaticniBroj').value)
          .subscribe((data: CompanyData[]) => {
              this.loadingCompanyData = false;
              if(!data || data.length == 0){
                this.translateService.get(['NBS.MATICNIBROJ.WARNING'])
                  .subscribe(translate => {
                    // this.notificationsService.alert(translate['NBS.MATICNIBROJ.WARNING']);
                    this.toastrService.info(translate['NBS.MATICNIBROJ.WARNING']);
                    return;
                  });
                  // alert('Ne postoje podaci za uneti MATIČNI BROJ');
                  // return;
              }
              this.setCompanyData(data[0]);
          })    
    }

    setCompanyData(data:CompanyData) {
      this.baseFormGroup.patchValue({Naziv: data.ShortName != "" ? data.ShortName : data.Name
                                    , MatBr: data.NationalIdentificationNumber
                                    , Adresa: data.Address
                                    , Pib: data.TaxIdentificationNumber
                                    , MestoID: data["CityID"] })
    }
}
